import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AppService } from 'src/app/app.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DoctorSocialService {

  constructor(
    private http: HttpClient,
    public app: AppService,
    private toaster: ToastrService,
  ) { }

  searchPosts = (req: FormData) => {
    if (this?.app?.isContributor) {
      if (!this?.app?.getSelectedHcpForCont()) {
        return this.http.post<any>(environment.baseUrl + "SocialMedia/Posts/List", req);
      } else {
        return this.http.post<any>(environment.baseUrl + `SocialMedia/Contribution/List/${this.app.getSelectedHcpForCont()}`, req);
      }
    } else {
      return this.http.post<any>(environment.baseUrl + "SocialMedia/Posts/List", req);
    }
  }

  searchPostsListSSR = (req: Object) => this.http.post<any>(environment.baseUrl + "SocialMedia/Posts/ListSSR", req);

  getInterestsRelatedToUser = () => {
    if (this?.app?.isContributor) {
      if (this?.app?.getSelectedHcpForCont()) {
        return this.http.get<any>(environment.baseUrl + "SocialMedia/Contribution/InterestedCategories/" + this.app.getSelectedHcpForCont());
      } else {
        return this.http.get<any>(environment.baseUrl + "SocialMedia/Posts/InterestedCategories");
      }
    } else {
      return this.http.get<any>(environment.baseUrl + "SocialMedia/Posts/InterestedCategories");
    }

  }

  getCategories = () => this.http.get<any>(environment.baseUrl + "SocialMedia/Categories/Lookup");

  linkCategoryWithHcp = (req: Object) => this.http.post<any>(environment.baseUrl + "SocialMedia/Posts/Link2Categories", req);

  postFeed = (req: FormData) => {
    if (this?.app?.isContributor) {
      if (!this?.app?.getSelectedHcpForCont()) {
        this.toasterContHcpNotSelected();
        return
      } else {
        return this.http.post<any>(environment.baseUrl + `SocialMedia/Contribution/Create/${this.app.getSelectedHcpForCont()}`, req);
      }
    } else {
      return this.http.post<any>(environment.baseUrl + "SocialMedia/Posts/Create", req);
    }
  }

  patchFeed = (id: number, req: FormData) => {
    if (this?.app?.isContributor) {
      if (!this?.app?.getSelectedHcpForCont()) {
        this.toasterContHcpNotSelected();
        return
      } else {
        return this.http.patch<any>(environment.baseUrl + `SocialMedia/Contribution/Update/${this.app.getSelectedHcpForCont()}/${id}`, req);
      }
    } else {
      return this.http.patch<any>(environment.baseUrl + "SocialMedia/Posts/Update/" + id, req);
    }
  }

  // /api/SocialMedia/Contribution/Get/{UserId}/{PostId}
  getPostById = (id: number) => {
    if (this?.app?.isContributor) {
      if (!this?.app?.getSelectedHcpForCont()) {
        return this.http.get<any>(environment.baseUrl + "SocialMedia/Posts/Get/" + id);
      } else {
        return this.http.get<any>(environment.baseUrl + `SocialMedia/Contribution/Get/${this.app.getSelectedHcpForCont()}/${id}`);
      }
    } else {
      return this.http.get<any>(environment.baseUrl + "SocialMedia/Posts/Get/" + id);
    }
  }

  getPostViews = (postId, pageSize, pageNumber) => this.http.get<any>(environment.baseUrl + `SocialMedia/Posts/PostViews/${postId}/${pageSize}/${pageNumber}`);

  getStories = () => this.http.get<any>(environment.baseUrl + "SocialMedia/Posts/LatestStories?PageSize=30&PageNumber=1");

  likePost = (id: number) => {
    if (this?.app?.isContributor) {
      if (!this?.app?.getSelectedHcpForCont()) {
        this.toasterContHcpNotSelected();
        return
      } else {
        return this.http.get<any>(environment.baseUrl + `SocialMedia/Contribution/LikePost/${this.app.getSelectedHcpForCont()}/${id}`);
      }
    } else {
      return this.http.get<any>(environment.baseUrl + "SocialMedia/Posts/LikePost/" + id);
    }
  }

  unlikePost = (id: number) => {
    if (this?.app?.isContributor) {
      if (!this?.app?.getSelectedHcpForCont()) {
        this.toasterContHcpNotSelected();
        return
      } else {
        return this.http.delete<any>(environment.baseUrl + `SocialMedia/Contribution/UnLikePost/${this.app.getSelectedHcpForCont()}/${id}`);
      }
    } else {
      return this.http.delete<any>(environment.baseUrl + "SocialMedia/Posts/UnLikePost/" + id);
    }
  }

  getNotifications = (PageSize: number, PageNumber: number) => {
    if (this?.app?.isContributor) {
      if (!this?.app?.getSelectedHcpForCont()) {
        this.toasterContHcpNotSelected();
        return
      } else {
        return this.http.get<any>(environment.baseUrl + `SocialMedia/Contribution/MyNotifications/${this.app.getSelectedHcpForCont()}/${PageSize}/${PageNumber}`);
      }
    } else {
      return this.http.get<any>(environment.baseUrl + `SocialMedia/Posts/MyNotifications/${PageSize}/${PageNumber}`);
    }
  }

  deleteMyPost = (id: number) => {
    if (this?.app?.isContributor) {
      if (!this?.app?.getSelectedHcpForCont()) {
        this.toasterContHcpNotSelected();
        return
      } else {
        return this.http.delete<any>(environment.baseUrl + `SocialMedia/Contribution/Delete/${this.app.getSelectedHcpForCont()}/${id}`);
      }
    } else {
      return this.http.delete<any>(environment.baseUrl + "SocialMedia/Posts/Delete/" + id);
    }
  }

  pinPost = (id: number) => {
    if (this?.app?.isContributor) {
      if (!this?.app?.getSelectedHcpForCont()) {
        this.toasterContHcpNotSelected();
        return
      } else {
        return this.http.get<any>(environment.baseUrl + `SocialMedia/Contribution/PinPost/${this.app.getSelectedHcpForCont()}/${id}`);
      }
    } else {
      return this.http.get<any>(environment.baseUrl + "SocialMedia/Posts/PinPost/" + id);
    }
  }

  unpinPost = (id: number) => {
    if (this?.app?.isContributor) {
      if (!this?.app?.getSelectedHcpForCont()) {
        this.toasterContHcpNotSelected();
        return
      } else {
        return this.http.delete<any>(environment.baseUrl + `SocialMedia/Contribution/UnPinPost/${this.app.getSelectedHcpForCont()}/${id}`);
      }
    } else {
      return this.http.delete<any>(environment.baseUrl + "SocialMedia/Posts/UnPinPost/" + id);
    }
  }

  likeComment = (id: number) => {
    if (this?.app?.isContributor) {
      if (!this?.app?.getSelectedHcpForCont()) {
        this.toasterContHcpNotSelected();
        return
      } else {
        return this.http.get<any>(environment.baseUrl + `SocialMedia/Contribution/LikeComment/${this.app.getSelectedHcpForCont()}/${id}`);
      }
    } else {
      return this.http.get<any>(environment.baseUrl + "SocialMedia/Posts/LikeComment/" + id);
    }
  }

  unlikeComment = (id: number) => {
    if (this?.app?.isContributor) {
      if (!this?.app?.getSelectedHcpForCont()) {
        this.toasterContHcpNotSelected();
        return
      } else {
        return this.http.delete<any>(environment.baseUrl + `SocialMedia/Contribution/UnLikeComment/${this.app.getSelectedHcpForCont()}/${id}`);
      }
    } else {
      return this.http.delete<any>(environment.baseUrl + "SocialMedia/Posts/UnLikeComment/" + id);
    }
  }


  getPostLikes = (postId, pageSize, pageNumber) => this.http.get<any>(environment.baseUrl + `SocialMedia/Posts/ShowPostLikes/${postId}/${pageSize}/${pageNumber}`);

  getCommentsLikes = (CommentId, pageSize, pageNumber) => this.http.get<any>(environment.baseUrl + `SocialMedia/Posts/ShowCommentLikes/${CommentId}/${pageSize}/${pageNumber}`);

  sendComment = (req: FormData, id: number) => {
    if (this?.app?.isContributor) {
      if (!this?.app?.getSelectedHcpForCont()) {
        this.toasterContHcpNotSelected();
        return
      } else {
        return this.http.post<any>(environment.baseUrl + `SocialMedia/Contribution/Comment/${this.app.getSelectedHcpForCont()}/${id}`, req);
      }
    } else {
      return this.http.post<any>(environment.baseUrl + "SocialMedia/Posts/Comment/" + id, req);
    }
  }

  getMainComments = (postId, pageSize, pageNumber) => {
    if (this?.app?.isContributor) {
      if (!this?.app?.getSelectedHcpForCont()) {
        return this.http.get<any>(environment.baseUrl + `SocialMedia/Posts/Comments/${postId}/${pageSize}/${pageNumber}`);
      } else {
        return this.http.get<any>(environment.baseUrl + `SocialMedia/Contribution/Comments/${this.app.getSelectedHcpForCont()}/${postId}/${pageSize}/${pageNumber}`);
      }
    } else {
      return this.http.get<any>(environment.baseUrl + `SocialMedia/Posts/Comments/${postId}/${pageSize}/${pageNumber}`);
    }
  }

  getSubComments = (CommentId, pageSize, pageNumber) => {
    if (this?.app?.isContributor) {
      if (!this?.app?.getSelectedHcpForCont()) {
        return this.http.get<any>(environment.baseUrl + `SocialMedia/Posts/SubComments/${CommentId}/${pageSize}/${pageNumber}`);
      } else {
        return this.http.get<any>(environment.baseUrl + `SocialMedia/Contribution/SubComments/${this.app.getSelectedHcpForCont()}/${CommentId}/${pageSize}/${pageNumber}`);
      }
    } else {
      return this.http.get<any>(environment.baseUrl + `SocialMedia/Posts/SubComments/${CommentId}/${pageSize}/${pageNumber}`);
    }
  }

  savePost = (id: number) => {
    if (this?.app?.isContributor) {
      if (!this?.app?.getSelectedHcpForCont()) {
        this.toasterContHcpNotSelected();
        return
      } else {
        return this.http.get<any>(environment.baseUrl + `SocialMedia/Contribution/SavePost/${this.app.getSelectedHcpForCont()}/${id}`);
      }
    } else {
      return this.http.get<any>(environment.baseUrl + "SocialMedia/Posts/SavePost/" + id);
    }
  }

  unSavePost = (id: number) => {
    if (this?.app?.isContributor) {
      if (!this?.app?.getSelectedHcpForCont()) {
        this.toasterContHcpNotSelected();
        return
      } else {
        return this.http.delete<any>(environment.baseUrl + `SocialMedia/Contribution/DeleteSaved/${this.app.getSelectedHcpForCont()}/${id}`);
      }
    } else {
      return this.http.delete<any>(environment.baseUrl + "SocialMedia/Posts/DeleteSaved/" + id);
    }
  }

  interestedPost = (id: number) => this.http.get<any>(environment.baseUrl + "SocialMedia/Posts/InterestedPost/" + id);

  unInterestedPost = (id: number) => this.http.delete<any>(environment.baseUrl + "SocialMedia/Posts/DeleteIntereste/" + id);

  reportPost = (req: FormData, id: number) => {
    if (this?.app?.isContributor) {
      if (!this?.app?.getSelectedHcpForCont()) {
        this.toasterContHcpNotSelected();
        return
      } else {
        return this.http.post<any>(environment.baseUrl + `SocialMedia/Contribution/Report/${this.app.getSelectedHcpForCont()}/${id}`, req);
      }
    } else {
      return this.http.post<any>(environment.baseUrl + "SocialMedia/Posts/Report/" + id, req);
    }
  }

  savedPosts = (req: Object) => this.http.post<any>(environment.baseUrl + "SocialMedia/Posts/SavedPosts", req);

  likedPosts = (req: Object) => this.http.post<any>(environment.baseUrl + "SocialMedia/Posts/ShowMyLikes", req);

  commentedPosts = (req: Object) => this.http.post<any>(environment.baseUrl + "SocialMedia/Posts/MyCommentedPosts", req);

  getAds = (pageSize, pageNum) => this.http.get<any>(environment.baseUrl + `Advertisments/Published/Active/${pageSize}/${pageNum}`);

  getInsights = (postId) => this.http.get<any>(environment.baseUrl + `SocialMedia/Posts/Insights/${postId}`);

  createDynamicLink = (req: Object) => this.http.post<any>("https://firebasedynamiclinks.googleapis.com/v1/shortLinks?key=AIzaSyByGefpW2cKUQotHB1tLFmbe14e3KTbCsI", req)

  getBoostInfo = () => this.http.get<any>(environment.baseUrl + `SocialMedia/SocialBoosting/Users/GetConfig`);

  deleteComment = (id: number) => {
    if (this?.app?.isContributor) {
      if (!this?.app?.getSelectedHcpForCont()) {
        this.toasterContHcpNotSelected();
        return
      } else {
        return this.http.delete<any>(environment.baseUrl + `SocialMedia/Contribution/DeleteComment/${this.app.getSelectedHcpForCont()}/${id}`);
      }
    } else {
      return this.http.delete<any>(environment.baseUrl + "SocialMedia/Posts/DeleteComment/" + id);
    }
  }
  toasterContHcpNotSelected() {
    if (this?.app?.getUserLanguage() == 'en') {
      this.toaster.error("Please Choose One User");
    } else if (this?.app?.getUserLanguage() == 'ar') {
      this.toaster.error("الرجاء اختيار مستخدم");
    }
    this.app.dismissLoading();
  }

  getLinkPreviewData = (link) => this.http.get<any>(`https://api.linkpreview.net/?key=5097fa8f7d82610661d7ac0200f292fe&q=${link}`);

  // paymentMethods
  saveCardCheckOut = () => this.http.post<any>(environment.baseUrl + "Payment/Cards/Save/GetCheckoutId", null);

  getMyCards = () => this.http.get<any>(environment.baseUrl + `userCard/Search`);

  payBoostPostCheckOutId = (req: FormData) => this.http.post<any>(environment.baseUrl + "Payment/SocialMedia/Boosting/generateCheckoutId", req);
  // paymentMethods

}
